import { Reducer } from 'redux';

// Define the Question type
export interface Products {
  id: number;
  text: string;
}

const initialState: Products[] = [];

const productsReducer: Reducer<Products[], any> = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PRODUCTS':
      return action.payload;
    default:
      return state;
  }
};

export default productsReducer;
